import { render, staticRenderFns } from "./modelDetailN.vue?vue&type=template&id=6f90ebf3&scoped=true"
import script from "./modelDetailN.vue?vue&type=script&lang=js"
export * from "./modelDetailN.vue?vue&type=script&lang=js"
import style0 from "./modelDetailN.vue?vue&type=style&index=0&id=6f90ebf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90ebf3",
  null
  
)

export default component.exports